import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useLocation } from 'react-router-dom';

import { getSiteMapItem } from '../../utils/getSiteMapItem';
import { Breadcrumb } from './Breadcrumb';
import BreadcrumbsModuleCss from './Breadcrumbs.module.css';
import { HomeBreadcrumb } from './HomeBreadcrumb';

const block = bemCssModules(BreadcrumbsModuleCss);

export const Breadcrumbs: VFC = () => {
  const location = useLocation();
  const paths = location.pathname.split('/').filter((x) => x);
  paths.unshift('');

  return (
    <div
      key={location.pathname}
      className={block()}
    >
      <HomeBreadcrumb />
      {paths.map((path) => {
        const siteMapItem = getSiteMapItem(path);

        if (!siteMapItem) {
          return null;
        }

        return (
          <Breadcrumb
            key={siteMapItem.Path}
            {...siteMapItem}
          />
        );
      })}
    </div>
  );
};
